import { authenticatedFetchJson } from "@/services/utils/authenticatedFetch";

export async function closeSession(sessionId: string): Promise<{ status: string }> {
  try {
    const data = await authenticatedFetchJson<{ status: string }>("/api/heygen/close_session", {
      method: "POST",
      body: JSON.stringify({ session_id: sessionId }),
    });

    return data;
  } catch (error) {
    console.error("Error in closeSession:", error);
    throw error;
  }
}
